<template>
  <div class="flat-switch-content">
    <h1 class="subtitle has-text-weight-bold has-text-primary is-size-5">
        Deseja ignorar regras de cotação ?
    </h1>
    <div class="flat-switch">
      <p class=" is-size-10 p-switch" > {{ 'Não'}}</p>
      <sc-field>
        <sc-switch 
          :value="status"
          @input="toggleCommit" />
      </sc-field>
      <p class=" is-size-10"> {{ 'Sim' }} </p>
    </div>
    <sc-collapse>
      <div
          slot="trigger"
          class="panel-heading"
          role="button"
          aria-controls="contentIdForA11y2">
          <sc-icon 
            icon="info-circle" 
            class="additional-information__icon" 
            size="is-small" />
              <strong>O que é isso ?</strong>
      </div>
      <div class="panel-block">
        <p>
           Ao selecionar essa funcionalidade será possivel
           ignorar todas as regras de cotação cadastradas <br>
           nessa conta para realização dos testes de cotação.
        </p>
      </div>
     </sc-collapse>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScSwitch,
  ScField,
  ScCollapse,
  ScIcon,
} from '@intelipost-js/secure-components';

const {
  mapState,
  mapMutations,
} = createNamespacedHelpers('quote/freightQuote');
export default {
  name: 'sc-quote-rules',
  props: {
    fields: Object,
  },
  computed: {
    ...mapState([
      'loading',
      'skip_quote_rules',
    ]),
    status() {
      return this.skip_quote_rules;
    },
  },
  methods: {
    ...mapMutations([
      'setSkipQuoteRulesMode',
    ]),
    toggleCommit(event) {
      this.setSkipQuoteRulesMode(event);
    },
  },
  components: {
    ScSwitch,
    ScField,
    ScCollapse,
    ScIcon,
  },
};
</script>
<style lang="scss" scoped>
.additional-information__icon {
  margin-right: 5px;
}
.flat-switch {
    display: flex;
}
.p-switch {
    margin-right: 5px; 
}
.flat-switch-content {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 3px hsla(0,0%,4%,.1), 0 0 0 1px hsla(0,0%,4%,.1);
  margin-bottom: 1.5rem;
  padding: 7px;
}

.panel-heading {
  background-color: white;
}

.panel-heading strong {
  font-size: 14px
}

.panel-heading {
  font-size: 14px;
}

.panel-block p i {
  font-size: 8px;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-quote-rules/ScQuoteRules.vue